import CharacterAvatar from '../character-avatar';
import HeroStatTable from '../hero-stat-table';
import RecordAwardRow from '../record-award-row';

const mostPlayedHeroes = [
  {
    image: '/img/characters/11.png',
    alt: 'character-11',
    color: 'cyan',
    name: 'Luria',
    role: 'Support',
    timePlayed: '09:00:00',
    record: ['33', '8', '2'],
    medals: '3.17',
    winRate: { value: '63.33%', tooltip: { title: '2.65', direction: 'up' } },
    onFire: { value: '18.04%' },
    lastColLabel: 'Healing',
    lastCol: '15.662',
  },
  {
    image: '/img/characters/05.png',
    alt: 'character-05',
    color: 'red',
    name: 'Galium',
    role: 'Offense',
    timePlayed: '07:23:00',
    record: ['30', '6'],
    medals: '3.08',
    winRate: { value: '85.50%' },
    onFire: { value: '22.90%' },
    lastColLabel: 'Damage',
    lastCol: '14.307',
  },
  {
    image: '/img/characters/12.png',
    alt: 'character-12',
    color: 'cyan',
    name: 'Duvida',
    role: 'Support',
    timePlayed: '04:06:00',
    record: ['15', '5', '1'],
    medals: '3.53',
    winRate: { value: '42.20%' },
    onFire: { value: '20.03%', tooltip: { title: '2.50', direction: 'down' } },
    lastColLabel: 'Healing',
    lastCol: '17.799',
  },
  {
    image: '/img/characters/07.png',
    alt: 'character-07',
    color: 'blue',
    name: 'Rekson',
    role: 'Defense',
    timePlayed: '00:58:00',
    record: ['6', '2'],
    medals: '2.86',
    winRate: { value: '79.71%' },
    onFire: { value: '21.56%' },
    lastColLabel: 'Damage',
    lastCol: '12.422',
  },
  {
    image: '/img/characters/04.png',
    alt: 'character-04',
    color: 'violet',
    name: 'Vanstus',
    role: 'Tank',
    timePlayed: '00:42:00',
    record: ['1', '0'],
    medals: '3.00',
    winRate: { value: '92.58%' },
    onFire: { value: '48.05%' },
    lastColLabel: 'Damage',
    lastCol: '15.765',
  },
];

const recordsAndAwards = [
  {
    icon: '/img/icons/flag-record-icon.png',
    iconAlt: 'record-img',
    title: 'Most damage inflicted',
    hero: { image: '/img/characters/05.png', alt: 'character-05' },
    description: 'Inflicted 98.256 of damage in a single game. Hero: Galium',
    date: 'March 2019',
  },
  {
    icon: '/img/icons/cup-award-icon.png',
    iconAlt: 'award-img',
    title: 'Player of the year 2018',
    description: 'Awarded by the Xenowatch League organizers',
    date: 'November 2018',
  },
  {
    icon: '/img/icons/flag-record-icon.png',
    iconAlt: 'record-img',
    title: 'Fastest kill in league',
    hero: { image: '/img/characters/04.png', alt: 'character-04' },
    description: 'Killed an opponent 0.23 secs after the start. Hero: Vanstus',
    date: 'August 2018',
  },
  {
    icon: '/img/icons/flag-record-icon.png',
    iconAlt: 'record-img',
    title: 'Highest healing in world cup',
    hero: { image: '/img/characters/10.png', alt: 'character-10' },
    description: '42.125 healing done in a single game. Hero: Magina',
    date: 'February 2018',
  },
  {
    icon: '/img/icons/cup-award-icon.png',
    iconAlt: 'award-img',
    title: 'Player of the year 2014',
    description: 'Awarded by the Xenowatch Tournament founders',
    date: 'October 2014',
  },
  {
    icon: '/img/icons/flag-record-icon.png',
    iconAlt: 'record-img',
    title: 'Highest eliminations',
    hero: { image: '/img/characters/05.png', alt: 'character-05' },
    description: '43 eliminations in a single life. Hero: Galium',
    date: 'June 2014',
  },
];

<template>
  <div class='layout-body layout-item gutter-big'>
    <div class='widget-item'>
      <div class='section-title-wrap violet small-space'>
        <h2 class='section-title medium'>Career Stats</h2>
        <div class='section-title-separator'></div>
      </div>
      <div class='widget-match-box'>
        <div class='widget-simple-stats v2'>
          <div class='widget-simple-stat half'>
            <div class='widget-simple-stat-header'>
              <p class='widget-simple-stat-header-title'>This Year</p>
            </div>
            <div class='widget-simple-stat-rows'>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Games Played</p>
                <p class='widget-simple-stat-value'>8</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Games Won</p>
                <p class='widget-simple-stat-value'>7</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Games Lost</p>
                <p class='widget-simple-stat-value'>1</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Win Rate</p>
                <p class='widget-simple-stat-value'>92.6%</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Damage Inflicted</p>
                <p class='widget-simple-stat-value'>42.546</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Damage Received</p>
                <p class='widget-simple-stat-value'>31.369</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Game MVP's</p>
                <p class='widget-simple-stat-value'>1</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Most Played Hero</p>
                <div class='team-info-wrap small inverted'>
                  <CharacterAvatar @image='/img/characters/05.png' @alt='character-05' @size='small' @color='red' />
                  <div class='team-info'>
                    <p class='team-name'>Galium</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class='widget-simple-stat half'>
            <div class='widget-simple-stat-header'>
              <p class='widget-simple-stat-header-title'>Lifetime</p>
            </div>
            <div class='widget-simple-stat-rows'>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Games Played</p>
                <p class='widget-simple-stat-value'>94</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Games Won</p>
                <p class='widget-simple-stat-value'>82</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Games Lost</p>
                <p class='widget-simple-stat-value'>12</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Win Rate</p>
                <p class='widget-simple-stat-value'>78.43%</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Damage Inflicted</p>
                <p class='widget-simple-stat-value'>195.670</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Damage Received</p>
                <p class='widget-simple-stat-value'>160.448</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Game MVP's</p>
                <p class='widget-simple-stat-value'>37</p>
              </div>
              <div class='widget-simple-stat-row'>
                <p class='widget-simple-stat-title'>Most Played Hero</p>
                <div class='team-info-wrap small inverted'>
                  <CharacterAvatar @image='/img/characters/11.png' @alt='character-11' @size='small' @color='cyan' />
                  <div class='team-info'>
                    <p class='team-name'>Luria</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='widget-item'>
      <div class='section-title-wrap violet'>
        <h2 class='section-title medium'>Most Played Heroes</h2>
        <div class='section-title-separator'></div>
      </div>
      {{#each mostPlayedHeroes as |hero|}}
        <HeroStatTable @hero={{hero}} />
      {{/each}}
    </div>
    <div class='widget-item'>
      <div class='section-title-wrap violet small-space'>
        <h2 class='section-title medium'>Records &amp; Awards</h2>
        <div class='section-title-separator'></div>
      </div>
      <div class='table records'>
        <div class='table-row-header'>
          <div class='table-row-header-item left'>
            <p class='table-row-header-title'>Record/Award</p>
          </div>
          <div class='table-row-header-item left'>
            <p class='table-row-header-title'>Description</p>
          </div>
          <div class='table-row-header-item left'>
            <p class='table-row-header-title'>Date Awarded</p>
          </div>
        </div>
        <div class='table-rows'>
          {{#each recordsAndAwards as |row|}}
            <RecordAwardRow @row={{row}} />
          {{/each}}
        </div>
      </div>
    </div>
  </div>
</template>
